import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledDescription = styled(Flex)`
    background: transparent;
    border: 0;

    h1.ant-typography {
        margin-top: 0;
    }
`;
